import './WhatAreYouLookingFor.css';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import WhatAreYouLookingForToggleButton from './WhatAreYouLookingForToggleButton';
import eventEnable from '../core/eventEnable';
export default class WhatAreYouLookingForHouseType{
	constructor({siteJson, houseTypesViewModel,
		whatAreYouLookingForViewModel}){
		eventEnable(this);
		this._element = document.createElement('div');
		this._element.classList.add('housetype');
		this._createSetHouseTypesButton= this._createSetHouseTypesButton.bind(this);
		this._houseTypesAvailableWithOtherOptionsChanged= this._houseTypesAvailableWithOtherOptionsChanged.bind(this);
		this._get_setHouseTypes= this._get_setHouseTypes.bind(this);
		this._houseTypesChanged= this._houseTypesChanged.bind(this);
		this._toggleButtons = [];
		this._mapHouseTypeViewModelToButton = new Map();
		houseTypesViewModel.entries.forEach(houseTypeViewModel=>this._createSetHouseTypesButton(houseTypeViewModel));
		this._propertyBindingHouseTypes= PropertyBindingFactory
			.standard(this, whatAreYouLookingForViewModel, 'houseTypes', this._houseTypesChanged);
		this._propertyBindingHouseTypesAvailableWithOtherOptions = PropertyBindingFactory.standard(this,
		whatAreYouLookingForViewModel,
		'houseTypesAvailableWithOtherOptions', this._houseTypesAvailableWithOtherOptionsChanged);
	}
	_houseTypesChanged(value){
		this._toggleButtons.forEach(toggleButton=>toggleButton.unselect());
		if(!value)return;
		value.forEach(houseTypeViewModel=>this._mapHouseTypeViewModelToButton
			.get(houseTypeViewModel).select());
	}
	_houseTypesAvailableWithOtherOptionsChanged(value){
		this._toggleButtons.forEach(toggleButton=>{
			const houseTypeViewModel = toggleButton.value;
			toggleButton.setAvailableOption((!value)||value.indexOf(houseTypeViewModel)>=0);
		});
	}
	_createSetHouseTypesButton(houseTypeViewModel){
		const toggleButton = new WhatAreYouLookingForToggleButton({
			callbackClicked:this._get_setHouseTypes(houseTypeViewModel),
			text:houseTypeViewModel.name+'',
			value:houseTypeViewModel
		});
		this._mapHouseTypeViewModelToButton.set(houseTypeViewModel, toggleButton);
		this._element.appendChild(toggleButton.element);
		this._toggleButtons.push(toggleButton);
	}
	_get_setHouseTypes(houseTypeViewModel){
		return (toggleButton)=>{
			if(toggleButton.selected){
				toggleButton.unselect();
				this._propertyBindingHouseTypes.set(null);
				return;
			}
			this._propertyBindingHouseTypes.set([houseTypeViewModel]);
			this.dispatchEvent({type:'chose'});
		};
	}
	get element(){
		return this._element;
	}
}